import { type InfiniteData } from '@tanstack/query-core';
import { type ApiResponse } from '#shared/lib/http';
import { type MaybeRef, toValue, computed } from 'vue';

export function useFlatInfiniteData<T>(
  pages: MaybeRef<InfiniteData<ApiResponse<T[], unknown>> | undefined>
) {
  return computed(() => toValue(pages)?.pages.flatMap((page) => page.data));
}
